
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#3F4A58","fill-opacity":".7"}}),_c('path',{attrs:{"d":"M8.574 5.987c-.701 0-1.275.574-1.275 1.275v8.288a.638.638 0 001.275 0V7.9c0-.352.285-.638.637-.638h6.375a.638.638 0 000-1.275H8.574zm2.55 2.55c-.701 0-1.275.574-1.275 1.275v8.926c0 .7.574 1.274 1.275 1.274h7.012c.702 0 1.275-.573 1.275-1.274V9.812c0-.704-.57-1.275-1.275-1.275h-7.012zm1.912 2.55h3.188a.638.638 0 010 1.276h-3.188a.638.638 0 010-1.275zm0 2.55h3.188a.638.638 0 010 1.275h-3.188a.638.638 0 010-1.275zm0 2.55h3.188a.638.638 0 010 1.275h-3.188a.638.638 0 010-1.274z","fill":"#fff"}})])
          )
        }
      }
    